export const refreshMemberToken = async () => {
    try {
        const response = await fetch('https://app-fearless-february.samrruddhi.in/api/member/check-auth', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            if (data.authenticated && data.token) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.member));
                localStorage.setItem('userType', 'member');
                return data.token;
            }
        }
    } catch (error) {
        console.error('Token refresh failed:', error);
    }
    return null;
};